<p>
  export-detail-update-financial works!
</p>
